import { atom } from 'recoil';
import {
    UserCompany,
    SAAS_TOKEN_KEY,
    MKP_TOKEN_KEY,
} from '@kiute-tech/network-kiute-pro';

export interface AuthState {
    loggedIn: boolean;
    isLoadingUser: boolean;
    userInfo?: UserCompany;
    marketplaceActivated: boolean;
}

export const isLoggedIn = (): boolean =>
    Boolean(localStorage?.getItem(SAAS_TOKEN_KEY));

export const isMarketplaceActivated = (): boolean =>
    !!localStorage?.getItem(MKP_TOKEN_KEY);

export const authState = atom({
    key: 'authState',
    default: {
        loggedIn: isLoggedIn(),
        isLoadingUser: false,
        userInfo: {} as UserCompany,
        marketplaceActivated: isMarketplaceActivated(),
    } as AuthState,
});
